

import { h } from 'preact';

export default function (props) {
    var styles = props.styles;
    var rest = Object.assign({}, props);
    delete rest.styles;

    return h('svg', Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"22"}, rest), [h('g', {"fill":"none","fill-rule":"evenodd"}, [h('rect', {"width":"20.5","height":"20.5","x":".75","y":".75","stroke":"#262626","stroke-width":"1.5","rx":"4"}, []), h('path', {"fill":"#262626","d":"M11 6a1 1 0 0 1 1 1v2.999L15 10a1 1 0 0 1 0 2h-3v3a1 1 0 0 1-2 0v-3H7a1 1 0 0 1 0-2h3V7a1 1 0 0 1 1-1Z"}, [])])]);
};

        